import Markdown, { type Components } from 'react-markdown'
import remarkGfm from 'remark-gfm'
import { cn } from '@/lib/utils'

// One renderer for issue/comment bodies, the comment-composer preview and the
// docs viewer. Prefers GitHub's pre-rendered, pre-sanitised `bodyHTML` (exact
// parity, incl. raw HTML in helpdesk-synced emails); falls back to client-side
// markdown (optimistic updates, the composer preview, docs). The prose styling
// — incl. `dark:prose-invert` and the table-overflow guard — lives here so all
// three render identically (they had drifted: the HTML path lacked dark mode).
const PROSE =
  'prose prose-sm dark:prose-invert max-w-none [&_code]:font-mono ' +
  '[&_table]:block [&_table]:max-w-full [&_table]:overflow-x-auto'

export function RichContent({
  html,
  markdown,
  className,
  components,
}: {
  html?: string | null
  markdown?: string
  className?: string
  /** react-markdown element overrides (e.g. the docs in-app link router). */
  components?: Components
}) {
  if (html) {
    return <div className={cn(PROSE, className)} dangerouslySetInnerHTML={{ __html: html }} />
  }
  return (
    <div className={cn(PROSE, className)}>
      <Markdown remarkPlugins={[remarkGfm]} components={components}>
        {markdown ?? ''}
      </Markdown>
    </div>
  )
}
